import React from "react";
import { useButtonsActions } from "../../hooks/useButtonsActions";
import { DetailItem } from "../DetailItem";
import { Subtitle } from "../Subtitle";
import "./styles.scss";

interface Section8Props {}

function Section8({}: Section8Props) {
  const faqs = [
    {
      title: "O que é o boleto parcelado da Koin?",
      text: "<p>Boleto Parcelado Koin é o novo meio de pagamento para as suas compras online. Compre em uma loja indicada em nosso site (<a href='https://parcele.koin.com.br'>parcele.koin.com.br</a>) e parcele o seu boleto conosco.</p>",
    },
    {
      title:
        "Posso usar o Boleto Parcelado da Koin para comprar em qualquer loja?",
      text: "<p>O cliente pré-aprovado poderá comprar apenas nas lojas indicadas. Para acessá-las, consulte o nosso site (<a href='https://parcele.koin.com.br'>parcele.koin.com.br</a>) para mais detalhes.</p>",
    },
    {
      title: "Existe um limite de valor?",
      text: "<p>Sim! Cada cliente pré-aprovado terá um limite de valor liberado, este que poderá ser utilizado de acordo com a validade estabelecida. Confira no e-mail que te enviamos a validade da proposta.</p>",
    },

    {
      title: `Posso utilizar o Boleto Parcelado da Koin para realizar mais de uma compra dentro do meu  limite?`,
      text: `<p>Nesta versão do Boleto Parcelado da Koin será possível apenas uma única compra, voltada para itens que estejam com o valor dentro do limite pré-estabelecido.</p>`,
    },
    {
      title: `Quais produtos posso comprar?
      `,
      text: `<p>Você pode comprar qualquer produto dentro das lojas indicadas. Para mais informações, consulte a nossa página <a href='https://parcele.koin.com.br'>parcele.koin.com.br</a>.</p>`,
    },
    {
      title: `Preciso passar por alguma análise de crédito?`,
      text: `<p>Sim, são duas etapas de análise de crédito. Caso você tenha recebido o e-mail, significa que sua análise está com o status de pré-aprovação. Assim, ao encaminhar o seu boleto, realizaremos a segunda etapa. Caso aprovado, daremos sequência a sua proposta.</p> `,
    },
    {
      title: `Meu pedido foi reprovado e agora?`,
      text: `<p>Caso isso aconteça, entre em contato com o nosso  <a href="https://koin.com.br/atendimento" target="_blank" rel="noreferrer">atendimento</a> selecionando a opção meus pedidos`,
    },
    {
      title: `O que devo fazer após realizar a compra na loja?`,
      text: `<p>Após a compra na loja indicada, você poderá enviar o boleto em “pdf” pelo formulário de envio disponível no site <a href="https://parcele.koin.com.br">parcele.koin.com.br</a> ou através do e-mail <a href="mailto:boletoparcelado@koin.com.br">boletoparcelado@koin.com.br</a>. Após o envio, faremos a análise do boleto e você receberá um retorno via e-mail.
      </p>`,
    },
    {
      title: `Por onde será feito o atendimento?`,
      text: `<p>Caso tenha alguma dúvida, você poderá nos acionar através do e-mail <a href="mailto:boletoparcelado@koin.com.br">boletoparcelado@koin.com.br</a>.</p>`,
    },
    {
      title: `Por onde devo enviar o boleto gerado na loja?`,
      text: `<p>O boleto poderá ser enviado pelo "formulário de envio disponível" na página (<a href="https://parcele.koin.com.br">parcele.koin.com.br</a>) ou através do e-mail <a href="mailto://boletoparcelado@koin.com.br">boletoparcelado@koin.com.br</a></p>`,
    },
    {
      title: `Posso parcelar a compra em quantas vezes no boleto?`,
      text: `<p>A quantidade de parcelas disponíveis dependerá do valor da compra e será informada durante o processo de pagamento.</p>`,
    },
    {
      title: `Posso fazer outro parcelamento com um ainda em andamento?`,
      text: `<p>É necessário finalizar o pagamento do parcelamento anterior para realizar um novo.</p>`,
    },
    {
      title: `Quando meu produto será enviado?`,
      text: `<p>A Koin oferece o método de pagamento via Boleto Parcelado, quando se trata do processo de separação, envio e entrega do produto, é de responsabilidade da loja escolhida. O mesmo serve para a consulta do status do pedido, prazos de entrega e demais serviços.</p>`,
    },
    {
      title: `Como cancelar o meu pedido?`,
      text: `<p>O cancelamento deverá ser feito na loja que você efetuou o pedido. O valor será devolvido de acordo com as condições da loja, mas a sua dívida com a Koin continuará em aberto. Para mais informações, entre em contato com o nosso atendimento através do e-mail <a href="mailto:boletoparcelado@koin.com.br">boletoparcelado@koin.com.br</a> ou no nosso <a href="https://koin.com.br/atendimento">chat</a> selecionando a opção meus pedidos.</p>`,
    },
    {
      title: `Cancelaram meu pedido sem minha autorização. O que devo fazer?`,
      text: `<p>Caso isso aconteça, entre em contato com a loja que você efetuou o pedido para entender a situação.
      </p> <p>Para acessar o site da loja, acesse <a href="parcele.koin.com.br">parcele.koin.com.br</a>.
      </p>`,
    },
    {
      title: `Como faço a devolução do produto por desistência?`,
      text: `<p>A devolução do produto deverá ser feita na loja que você efetuou o pedido. Entre em contato com a loja para entender as políticas e termos estabelecidos.</p>`,
    },
    {
      title: `O produto veio errado ou com defeito. Como prosseguir?`,
      text: `<p>Caso o produto venha errado ou com defeito, entre em contato com a loja que você efetuou o pedido para solicitar a troca pelo produto correto ou sem defeito.</p>`,
    },
    {
      title: `Paguei a primeira parcela. Em quanto tempo o boleto da loja é quitado?`,
      text: `<p>O pagamento será realizado em até 1 dia útil após quitar o boleto.</p>`,
    },
    {
      title: `Paguei o boleto da Koin, mas o pedido foi cancelado. Como proceder?`,
      text: `<p>Em caso de cancelamento, entre em contato com a loja para entender a situação do seu pedido e caso necessário realize uma nova compra.</p>`,
    },
    {
      title: `Meu produto não chegou, o que fazer?`,
      text: `<p>Caso o produto não tenha sido entregue, entre em contato com a loja que você efetuou o pedido.
      </p>`,
    },
    {
      title: `Qual o prazo para pagamento do boleto Koin?`,
      text: `<p>O pagamento do Boleto Parcelado da Koin deverá ser realizado no mesmo dia em horário comercial (09:00 às 18:00).</p>`,
    },
    {
      title: "Como é feito o reembolso do pagamento?",
      text: "<p>O reembolso deverá ser feito pela loja que você efetuou o pedido. O valor do produto será devolvido de acordo com a política da loja onde você realizou a compra. Lembre-se que o parcelamento do seu produto com a Koin continuará em aberto, e caso queira quitar em uma única parcela, será necessário entrar em contato conosco através dos nossos canais de <a target='_blank' rel='noreferrer' href='https://koin.com.br/atendimento'>atendimento</a>.</p>",
    },
  ];

  const { sendMail, call } = useButtonsActions();

  return (
    <section className="section8" id="faq">
      <div>
        <div className="faq">
          <div className="infos">
            <Subtitle text="Dúvidas frequentes" />
          </div>

          {faqs.map(({ text, title }, index) => (
            <DetailItem
              key={title}
              title={`${index + 1} - ${title}`}
              text={text}
              id={`faqItem${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export { Section8 };
